import pcbanglogotitle from './pcbanglogotitle.png'
import submitsearch from './magnifier.png'
import { isEmptyOrSpaces, useGoto } from './util'
import { useLocation } from 'react-router-dom'
import CustomLink from './CustomLink'
import $ from 'jquery'

// var paths = ["home", "shop", "map", "blogs", "galerie", "contact"]
export const NavLink = (props) => {
	const cls = props.cls
	const match = props.match
	const location = useLocation().pathname.substring(1);
	console.log(location)
	var highlight = location.startsWith(cls) || match.some(string => string === location)
	return (
		<CustomLink {...props} className={"navtext navlistitem navlink " + cls} to={"/" + cls} style={{ ...(highlight) && { color: "#ff0099" } }}>{capitalize(cls)}</CustomLink>
	);
}

NavLink.defaultProps = {
	match: []
}

function capitalize(string) {
	return string[0].toUpperCase() + string.substring(1)
}

export function checkclickoutside(e, p) {
	if (!document.getElementById('slidingmenu').contains(e.target) && $("#slidingmenu").hasClass("togglemenu")) {
		// console.log("ran????")
		window.removeEventListener('click', checkclickoutside)
		$("#slidingmenu").removeClass("togglemenu")
	}
}

const Navbar = () => {
	// const location = useLocation();
	// console.log(location.pathname);
	return (
		<nav className="navbar">
			<div className="navitem more sides">
				{/* <div className="navtext">
				</div> */}
				<svg className="burgersvg" style={{ width: "28px", height: "20px" }} width="16" height="11" viewBox="0 0 16 11" fill="#f2f2f2" xmlns="http://www.w3.org/2000/svg"
					onClick={() => {
						// console.log("test clicked svg????")
						$("#slidingmenu").addClass("togglemenu")
						setTimeout(() => window.addEventListener('click', checkclickoutside), 400)
					}}
				>
					<rect width="16" height="1"></rect>
					<rect y="5" width="16" height="1"></rect>
					<rect y="10" width="16" height="1"></rect>
				</svg>
			</div>
			<ul className="navlist navitem">
				<NavLink cls={"home"} match={[""]} />
				<a className={"navtext navlistitem navlink shop"} style={{ textDecoration: "none" }} href="https://shop.pcbang.ma">Shop</a>
				<NavLink cls={"blogs"} />
				<li className="navtext navlistitem circle" onClick={useGoto("/")} style={{ cursor: "pointer", position: "relative", zIndex: 5 }}>
					<div className="container">
						<img src={pcbanglogotitle} alt="" className="img" />
					</div>
				</li>
				<NavLink cls={"galerie"} />
				<NavLink cls={"map"} />
				<NavLink cls={"contact"} match={["contact-us"]} />
			</ul>
			<div className="navitem navtext search sides">
				<form action="" className="searchform" onSubmit={(e) => {
					e.preventDefault()
					if (!isEmptyOrSpaces($("#blogquery").val()))
						window.location = "/blogs?name=" + $("#blogquery").val()
				}}>
					<input type="text" className="searchbox sb" placeholder='SEARCH' id="blogquery" />
					<input type="image" className='submitbutton sb' alt="" src={submitsearch} />
					<input type="image" id="nsb" className='submitbutton nsb' alt="" src={submitsearch}
						// style={{...(clicked && {display: "none"})}}
						onClick={() => {
							// setclicked(false)
							// setTimeout(() => {
							if (!$("#slidingmenu").hasClass("togglemenu")) {
								$("#slidingmenu").addClass("togglemenu")
							}
							else {
								$("#slidingmenu").removeClass("togglemenu")
							}
								// console.log("set timeout onclick search")
								// setTimeout(() =>
								// window.addEventListener('click', (e) => {
								// 	if (!document.getElementById('slidingmenu').contains(e.target) && $("#slidingmenu").hasClass("togglemenu")) {
								// 		// console.log("ran????")
								// 		$("#cnsb").attr("style", "display: none")
								// 		window.removeEventListener('click', checkclickoutside)
								// 		$("#slidingmenu").removeClass("togglemenu")
								// 	}
								// 	// setclicked(false)
								// })
								// , 400)
						// }, 100)
						}}/>
					{/* <svg className='nsb' id="cnsb"
						width="24" height="24" fill="#ff0099" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" 
						style={{display: "none"}}
						onClick={(e) => {
							if ($("#slidingmenu").hasClass("togglemenu")) {
								$("#slidingmenu").removeClass("togglemenu")
							}
							toggle(true)
						}}
					>
						<path d="M2.219.781L.78 2.22 9.562 11l-8.78 8.781 1.437 1.438L11 12.437l8.781 8.782 1.438-1.438L12.437 11l8.782-8.781L19.78.78 11 9.562 2.219.783z"></path>
					</svg> */}
				</form>
			</div>
		</nav>
	);
}

export default Navbar;
